import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconFeedbackFilledStyle0 = cosmosIconCss;

const CosmosIconFeedbackFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFeedbackFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '7b8cff8f10be294ab2b4280c8fee6a43b7ee4a57', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '5eb95a4a58b7676118432bfd6cbc63ca93446512', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '1724d55608f5345f481b82628cac18c139a46bfa', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.022 14.973A7.052 7.052 0 0 1 2 10.009C2 6.135 5.097 3 8.925 3h4.129c1.914 0 3.634.784 4.903 2.046.301.305.58.632.817.98A7.012 7.012 0 0 1 20 9.988a7.027 7.027 0 0 1-2.946 5.747 9.09 9.09 0 0 0 1.656 2.699c.193.218.043.566-.237.566-2.15 0-4.129-.74-5.699-2.003H8.946a6.754 6.754 0 0 1-4.925-2.024Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconFeedbackFilledStyle0; }
}, [1, "cosmos-icon-feedback-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-feedback-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-feedback-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFeedbackFilled$1);
            }
            break;
    } });
}

const CosmosIconFeedbackFilled = CosmosIconFeedbackFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFeedbackFilled, defineCustomElement };
